








































































































/*tslint:disable*/
import { Component, Vue } from 'vue-property-decorator';
import { Bundle } from '@/connectors/bundles/bundle.model';
import MpCard from '@/components/controls/mp-card/MpCard.vue';
import MpBundleViewsByDateChartCard from '@/components/wrappers/bundle/statistics/MpBundleViewsByDateChartCard.vue';
import MpBundleViewsByParticipantTypeCard from '@/components/wrappers/bundle/statistics/MpBundleViewsByParticipantTypeCard.vue';
import { BundlesConnector } from '@/connectors/bundles/bundles.connector';
import { BundleStatistics } from '@/connectors/bundles/bundle-statistics.model';
import MpModalVideoPlayer from '@/components/wrappers/mp-modal-video-player/MpModalVideoPlayer.vue';
import { VideosConnector } from '@/connectors/videos/videos.connector';
import { KeyValuePair } from '@/connectors/kvp.model';
import MpBundleVideoStatistics from '@/components/wrappers/bundle/statistics/MpBundleVideoStatistics.vue';
import MpShowRatingCountsCard from '@/components/controls/mp-card/MpShowRatingCountsCard.vue';
import MpShowRatingCard from '@/components/controls/mp-card/MpShowRatingCard.vue';
import MpShowNumberCard from '@/components/controls/mp-card/MpShowNumberCard.vue';
/*tslint:enable*/
@Component({
  components: {
    MpShowNumberCard,
    MpShowRatingCard,
    MpShowRatingCountsCard,
    MpBundleVideoStatistics,
    MpModalVideoPlayer,
    MpBundleViewsByParticipantTypeCard,
    MpBundleViewsByDateChartCard,
    MpCard
  }
})
export default class BundleByIdIndex extends Vue {
  bundlesConnector: BundlesConnector = new BundlesConnector();
  videosConnector: VideosConnector = new VideosConnector();

  pollingInterval: any = null;
  isRefreshing: boolean = false;

  $refs!: {
    thumbnailCard: MpCard;
  };
  cardsHeight: string = '';
  largeCardsHeight: string = '';

  bundle: Bundle | null = null;
  bundleStatistics: BundleStatistics | null = null;

  showVideoDialog: boolean = false;

  videoUrl: string = '';

  get isReady(): boolean {
    return !!this.bundle && !!this.bundleStatistics;
  }

  onThumbnailCardResize() {
    if (!!this.$refs.thumbnailCard) {
      this.cardsHeight = this.$refs.thumbnailCard.$el.clientHeight + 'px';
      this.largeCardsHeight = this.$refs.thumbnailCard.$el.clientHeight * 1.3 + 'px';
    }
  }

  async getNotRefreshingData() {
    if (!!this.bundle) {
      const videos = await this.videosConnector.getByBundleId(this.bundle.id);

      if (!!videos && videos.length > 0) {
        this.videoUrl = videos[0].url;
      }
    }
  }

  async getRefreshingData() {
    this.isRefreshing = true;
    this.bundle = await this.bundlesConnector.getById(this.$route.params.bundleId);
    this.bundleStatistics = await this.bundlesConnector.getStatisticsForBundleId(this.$route.params.bundleId);

    this.bundleStatistics.ratingCountByStars = this.bundleStatistics.ratingCountByStars.sort(r => r.key).reverse();
    this.isRefreshing = false;
  }

  async mounted() {
    await this.getRefreshingData();
    await this.getNotRefreshingData();
    this.pollingInterval = setInterval(
      this.getRefreshingData,
      this.$store.state.application.config.bundleStatisticsPollingDelayInSeconds * 1000
    );

    this.onThumbnailCardResize();
  }

  beforeDestroy() {
    clearInterval(this.pollingInterval);
  }
  async playVideo() {
    if (!this.bundleStatistics || this.bundleStatistics.videoStatistics.length !== 1 || !this.videoUrl) {
      return;
    }
    this.showVideoDialog = true;
  }
}
